import {TYPE_LOGOUT} from "./types";

export function logoutAction() {
	return {
		type: TYPE_LOGOUT,
	};
}
